import { FC } from 'react'
import DraftProductsList from "../../modules/products/DraftProductsList";

const DraftProductsListPage:FC = () => {
  return (
    <>
        <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-md-12 col-lg-12 mb-md-5 mb-xl-10'>
            <DraftProductsList />
        </div>
        </div>
    </>
  )
}

export default DraftProductsListPage